/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { useMutation } from "@tanstack/react-query";

// Services
import { AuthService } from "@/services/auth.service";

// Store
import usePhysiomKineStore from "@/stores/physiomKine";

/* -------------------------------------------------------------------------- */
/*                                  Logout Hook                                 */
/* -------------------------------------------------------------------------- */

const authService = new AuthService();

interface UseLogoutProps {
  onSuccess?: () => void;
}

const useLogout = ({ onSuccess }: UseLogoutProps) => {
  const { mutate, isPending } = useMutation({
    mutationFn: authService.logout,
    onSuccess: () => {
      const { logout } = usePhysiomKineStore.getState();
      logout();
      onSuccess?.();
    },
  });

  return { mutate, isPending };
};

export { useLogout };
